import React from "react";
import { Box, Paper, Skeleton, Divider, Stack, IconButton } from "@mui/material"
import { ArrowBack } from "@mui/icons-material"

const TicketSkeleton = () => {
  return (
    <Box sx={{ display: "flex", height: "100vh",  }}>
      <Paper
        sx={{
          flex: 1,
          p: 3,
          display: "flex",
          flexDirection: "column",
          borderRadius: 0,
          boxShadow: "none",
          borderRight: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
         
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="40%" height={20} />
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Skeleton variant="rectangular" width={80} height={24} sx={{ mr: 2, borderRadius: 1 }} />
          <Skeleton variant="text" width="50%" height={24} />
          <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
        </Box>

        <Box >
          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", maxWidth: "70%" }}>
              <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
              <Box>
                <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: 2, mb: 1 }} />
                <Skeleton variant="text" width={100} height={16} />
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", maxWidth: "70%" }}>
              <Box sx={{ mr: 2, textAlign: "right" }}>
                <Skeleton variant="rectangular" width={200} height={40} sx={{ borderRadius: 2, mb: 1 }} />
                <Skeleton variant="text" width={120} height={16} />
              </Box>
              <Skeleton variant="circular" width={40} height={40} />
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", maxWidth: "70%" }}>
              <Box sx={{ mr: 2, textAlign: "right" }}>
                <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: 2, mb: 1 }} />
                <Skeleton variant="text" width={100} height={16} />
              </Box>
              <Skeleton variant="circular" width={40} height={40} />
            </Box>
          </Box>

          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Skeleton variant="text" width={150} height={16} sx={{ mx: "auto" }} />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", maxWidth: "70%" }}>
              <Box sx={{ mr: 2, textAlign: "right" }}>
                <Skeleton variant="rectangular" width={160} height={40} sx={{ borderRadius: 2, mb: 1 }} />
                <Skeleton variant="text" width={80} height={16} />
              </Box>
              <Skeleton variant="circular" width={40} height={40} />
            </Box>
          </Box>

          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Skeleton variant="text" width={200} height={16} sx={{ mx: "auto", mb: 1 }} />
            <Skeleton variant="text" width={180} height={16} sx={{ mx: "auto", mb: 1 }} />
            <Skeleton variant="text" width={220} height={16} sx={{ mx: "auto", mb: 1 }} />
            <Skeleton variant="text" width={160} height={16} sx={{ mx: "auto", mb: 1 }} />
            <Skeleton variant="text" width={190} height={16} sx={{ mx: "auto" }} />
          </Box>
        </Box>

        <Box>
          <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: 2, mb: 2 }} />
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
            </Box>
          </Box>
        </Box>
      </Paper>

      <Paper
        sx={{
          width: 350,
          p: 3,
          borderRadius: 0,
          boxShadow: "none",
        }}
      >
        <Skeleton variant="text" width="60%" height={28} sx={{ mb: 3 }} />

        <Stack spacing={3}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
            <Skeleton variant="text" width={60} height={20} />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
              <Skeleton variant="text" width={70} height={20} />
            </Box>
            <Skeleton variant="text" width={90} height={20} />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
              <Skeleton variant="text" width={100} height={20} />
            </Box>
            <Skeleton variant="text" width={90} height={20} />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
              <Skeleton variant="text" width={60} height={20} />
            </Box>
            <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
              <Skeleton variant="text" width={60} height={20} />
            </Box>
            <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
              <Skeleton variant="text" width={60} height={20} />
            </Box>
            <Skeleton variant="text" width={40} height={20} />
          </Box>

          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Skeleton variant="text" width={50} height={20} />
              <Skeleton variant="text" width={80} height={16} />
            </Box>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Skeleton variant="rectangular" width={120} height={28} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={80} height={28} sx={{ borderRadius: 2 }} />
            </Box>
          </Box>

          <Divider />

          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Skeleton variant="text" width={80} height={24} />
              <Skeleton variant="text" width={60} height={16} />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
              <Box>
                <Skeleton variant="text" width={120} height={20} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width={160} height={16} />
              </Box>
            </Box>
          </Box>

          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Skeleton variant="text" width={60} height={24} />
              <Skeleton variant="text" width={80} height={16} />
            </Box>
            <Skeleton variant="text" width={140} height={20} />
          </Box>

          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Skeleton variant="text" width={80} height={24} />
              <Skeleton variant="text" width={60} height={16} />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
              <Box>
                <Skeleton variant="text" width={160} height={20} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width={180} height={16} />
              </Box>
            </Box>
          </Box>
        </Stack>
      </Paper>
    </Box>
  )
}

export default TicketSkeleton
